import mobileIcon from "../assets/icons/mobile.svg";
import webIcon from "../assets/icons/web.svg";
import designIcon from "../assets/icons/design.svg";
import devopsIcon from "../assets/icons/devops.svg";
import enterpriseIcon from "../assets/icons/entreprise.svg";
import cloudIcon from "../assets/icons/cloud.svg";
import { services } from "./services";
import { servicePath } from "../utils/serviceRoutes";

function urlForServiceId(id) {
  const s = services.find((x) => x.id === String(id));
  return s ? servicePath(s) : "/";
}

/** i18nKey maps to `industries.{key}.*` in locales; URLs follow live `services` slugs */
export const industries = [
  {
    id: 1,
    i18nKey: "mobile",
    url: urlForServiceId("8798"),
    icon: { src: mobileIcon },
  },
  {
    id: 2,
    i18nKey: "web",
    url: urlForServiceId("8799"),
    icon: { src: webIcon },
  },
  {
    id: 3,
    i18nKey: "design",
    url: urlForServiceId("8802"),
    icon: { src: designIcon },
  },
  {
    id: 4,
    i18nKey: "devops",
    url: urlForServiceId("54956"),
    icon: { src: devopsIcon },
  },
  {
    id: 5,
    i18nKey: "enterprise",
    url: urlForServiceId("54304"),
    icon: { src: enterpriseIcon },
  },
  {
    id: 6,
    i18nKey: "cloud",
    url: urlForServiceId("8801"),
    icon: { src: cloudIcon },
  },
];
